// 2026-10-14 신규 — 「8월에 번 돈 = 네이버 앱 「10월」 줄」 한 줄 (대표 결정 B안 · 제이 요청).
// 우리가 부르는 이름(「2026년 8월 수익」)은 그대로 두고, 네이버 앱에서 찾아야 할 줄의 큰 글씨를 옆에 붙인다.
// 홈 카드 · 정산 화면 상자 · 잠금 화면 · 제출 창이 같은 모양으로 쓴다. 문장은 lib naverRowEquation.
import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { naverRowEquation } from "../../lib/naverRevenue";

export default function NaverRowEquation({ card, size = "sm", ...rest }) {
  const eq = naverRowEquation(card);
  if (!eq) return null;
  const fs = size === "xs" ? "11px" : "12px";
  return (
    <Flex align="center" gap={1.5} wrap="wrap" fontSize={fs} fontWeight="800" data-testid="naver-row-equation" {...rest}>
      <Box as="span" bg="white" border="1px solid" borderColor="neutral.300" color="neutral.800" borderRadius="full" px={2.5} py={0.5}>{eq.earned}</Box>
      <Box as="span" color="neutral.500">=</Box>
      <Box as="span" bg="white" border="1.5px solid" borderColor="neutral.900" color="neutral.900" borderRadius="full" px={2.5} py={0.5}>{eq.row}</Box>
    </Flex>
  );
}
